export enum CertificationStatus {
  Active = 'Active',
  Incomplete = 'Incomplete',
  Expired = 'Expired'
}

export enum VerificationCategory {
  Assured = 4
}

export interface ICertification {
  id: string;
  name: string;
  status: CertificationStatus;
  validToDateTimeUtc: string;
  documentReferenceId: string;
  displayOrder: number;
  subscriptionId: string;
  isExpired?: boolean;
  verificationCategory: number | null;
  accreditationTypeId: string;
}
